// src/components/EmptyState.jsx
import React from 'react';
import { FaPlusCircle } from 'react-icons/fa';
import './EmptyState.css';

const EmptyState = ({ message, actionText, onActionClick }) => {
  return (
    <div className="empty-state-container">
      <p>{message}</p>
      {actionText && onActionClick && (
        <button className="btn btn-primary" onClick={onActionClick}>
          <FaPlusCircle /> {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;